import React from 'react';
import '../styles/authLoader.css';

const DevAuthHint = ({ error }) => {
  const exampleUrl = `${window.location.origin}/?telegram_id=123456789`;

  return (
    <div className="auth-loader-screen open-in-messenger-screen">
      <div className="auth-loader-cup-wrap" aria-hidden="true">
        <div className="auth-loader-cup">
          <div className="auth-loader-coffee" />
        </div>
        <div className="auth-loader-handle" />
      </div>

      <h1 className="auth-loader-title">Режим разработки</h1>
      <p className="auth-loader-subtitle open-in-messenger-text">
        Для входа без Telegram укажите ID пользователя из базы (seed: 123456789)
        в URL или задайте REACT_APP_DEV_TELEGRAM_ID в .env.
      </p>

      <p className="auth-loader-subtitle open-in-messenger-text">
        Пример:
        {' '}
        <a href={exampleUrl}>{exampleUrl}</a>
      </p>

      <p className="open-in-messenger-warning" role="status">
        На бэкенде должен быть включён DEBUG_MODE=1 (в docker-compose по умолчанию true).
      </p>

      {error ? <div className="auth-loader-error">{error}</div> : null}
    </div>
  );
};

export default DevAuthHint;
